export const spinnerSx = {
  position: 'static',
  bottom: '0',
  top: 'unset',
  transform: 'none',
  display: 'flex',
  justifyContent: 'center',
};
